<template>
  <div v-if="alternates.length > 1">
    <nav>
      <ul
        class="
          flex justify-end gap-10
          lg:mr-10
          print:hidden
        "
      >
        <template v-for="{ locale, url, language } in alternates">
          <li
            v-if="url"
            :key="url"
          >
            <AppButton
              :to="url"
              target="_self"
              class="
                text-gray-500 transition-colors
                hover-focus:text-red-500
              "
              :class="{ 'text-red-500': currentLocale === locale }"
            >
              {{ language }}
            </AppButton>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
const entry = inject(EntryInjectionKey)

const {
  locale: currentLocale, locales,
} = useI18n()

type Alternate = {
  locale: string
  url?: string
  language?: string
}
const alternates = computed<Alternate[]>(() => {
  if (Array.isArray(entry?.value?.alternates)) {
    // We have an entry from statamic

    const filteredAlternates = entry.value.alternates.filter(alternate => !!alternate) as Alternate[]
    filteredAlternates.forEach((alternate, index) => {
      if (!alternate) return
      const localeSite = locales.value.find(l => l.code === alternate.locale)

      // get the protocol of the current request
      const requestURL = useRequestURL()
      const { protocol } = requestURL

      const url = localeSite?.domain ? `${protocol}//${localeSite?.domain}` + alternate.url : alternate.url

      filteredAlternates[index] = {
        ...alternate,
        url,
      }
    })

    return filteredAlternates
  } else {
    // We do not have an entry from statamic, likely using nuxt pages instead, so we offer all available locales
    return locales.value.map((l) => {
      return { locale: l.code }
    })
  }
})
</script>
